export const initJson = {
  pages: [
    {
      name: 'preQuestions',
      elements: [
        {
          type: 'panel',
          name: 'formPreparation',
          fieldType: 'Standard',
          elements: [
            {
              type: 'checkbox',
              name: 'documentPreparation',
              title: {
                default: 'Please ready the following documents:',
                'zh-tw': '請準備好以下檔案：',
              },
              defaultValue: [
                'Identity Document',
                'Valid Visa and Passport/Permit (for non-resident)',
                'Colour Photo with business attire',
                'Education Proof',
                'Notifications of Result / Certificate of Insurance Intermediaries Qualifying Examination (IIQE)',
                'Residential Address Proof issued within the last 3 months',
                'Bank Account Proof',
              ],
              readOnly: true,
              isRequired: true,
              fieldType: 'Standard',
              choices: [
                {
                  value: 'Identity Document',
                  text: {
                    default: 'Identity Document',
                    'zh-tw': '身份證明檔案',
                  },
                },
                {
                  value: 'Valid Visa and Passport/Permit (for non-resident)',
                  text: {
                    default: 'Valid Visa and Passport/Permit (for non-resident)',
                    'zh-tw': '有效簽證和護照/許可證（非居民）',
                  },
                },
                {
                  value: 'Colour Photo with business attire',
                  text: {
                    default: 'Colour Photo with business attire',
                    'zh-tw': '商務裝彩色照片',
                  },
                },
                {
                  value: 'Education Proof',
                  text: {
                    default: 'Education Proof',
                    'zh-tw': '學歷證明',
                  },
                },
                {
                  value:
                    'Notifications of Result / Certificate of Insurance Intermediaries Qualifying Examination (IIQE)',
                  text: {
                    default:
                      'Notifications of Result / Certificate of Insurance Intermediaries Qualifying Examination (IIQE)',
                    'zh-tw': '保險仲介人資格考試成績通知書',
                  },
                },
                {
                  value: 'Residential Address Proof issued within the last 3 months',
                  text: {
                    default: 'Residential Address Proof issued within the last 3 months',
                    'zh-tw': '最近3個月內出具的居住地址證明',
                  },
                },
                {
                  value: 'Bank Account Proof',
                  text: {
                    default: 'Bank Account Proof',
                    'zh-tw': '銀行帳戶證明',
                  },
                },
              ],
              preset: 'secondary',
            },
            {
              type: 'checkbox',
              name: 'documentPreparation2',
              title: {
                default: 'Documents required subject to application details:',
                'zh-tw': '所需檔案以申請細節為准：',
              },
              defaultValue: [
                'Latest 12/24 months Income Proof',
                '"Authorization Letter" of debt information inquiry (if necessary)',
                'Recommendation Letter',
                'Supporting Documents for professional qualification and industrial awards (if necessary)',
              ],
              readOnly: true,
              isRequired: true,
              fieldType: 'Standard',
              choices: [
                {
                  value: 'Latest 12/24 months Income Proof',
                  text: {
                    default: 'Latest 12/24 months Income Proof',
                    'zh-tw': '最近12/24個月的收入證明',
                  },
                },
                {
                  value: '"Authorization Letter" of debt information inquiry (if necessary)',
                  text: {
                    default: '"Authorization Letter" of debt information inquiry (if necessary)',
                    'zh-tw': '債務資訊查詢“授權書”（如有必要）',
                  },
                },
                {
                  value: 'Recommendation Letter',
                  text: {
                    default: 'Recommendation Letter',
                    'zh-tw': '推薦信',
                  },
                },
                {
                  value: 'Supporting Documents for professional qualification and industrial awards (if necessary)',
                  text: {
                    default: 'Supporting Documents for professional qualification and industrial awards (if necessary)',
                    'zh-tw': '專業資格和行業獎項的證明檔案（如有必要）',
                  },
                },
              ],
              preset: 'secondary',
            },
          ],
          title: {
            default: 'Form Preparation',
            'zh-tw': '表格準備',
          },
        },
        {
          type: 'panel',
          name: 'confirmationQuestions',
          elements: [
            {
              type: 'boolean',
              name: 'pambPrubsnRights',
              title: {
                default:
                  'Prudential Assurance Malaysia Berhad (PAMB)/ Prudential BSN Takaful Malaysia Berhad (PruBSN) reserves the absolute right to reject or reconsider this application if information provided in this application is found to be incomplete or inaccurate.',
                'zh-tw':
                  'Prudential Assurance Malaysia Berhad (PAMB)/ Prudential BSN Takaful Malaysia Berhad (PruBSN) reserves the absolute right to reject or reconsider this application if information provided in this application is found to be incomplete or inaccurate.',
              },
              isRequired: true,
              labelTrue: {
                'zh-tw': '是',
                default: 'Yes',
              },
              labelFalse: {
                'zh-tw': '否',
                default: 'No',
              },
              titleLocation: 'left',
              validators: [
                {
                  type: 'expression',
                  expression: '{pambPrubsnRights} = true',
                  text: {
                    default: 'Please check this box',
                    'zh-tw': '請確認此選項',
                  },
                },
              ],
              preset: 'confirm_checkbox',
            },
            {
              type: 'boolean',
              name: 'rightsAndObligationsExplanation',
              title: {
                default:
                  "Have you explained to the insurance agent applicant the rights and obligations of both the agent and the Insurance Company under the Agent's Contract including the rights and obligations relateing to the following matters?",
                'zh-tw':
                  '您是否向保險代理人申請人解釋了代理人和保險公司在代理人契约下的權利和義務，包括與以下事項有關的權利和責任？',
              },
              isRequired: true,
              titleLocation: 'left',
              labelTrue: {
                'zh-tw': '是',
                default: 'Yes',
              },
              labelFalse: {
                'zh-tw': '否',
                default: 'No',
              },
              validators: [
                {
                  type: 'expression',
                  expression: '{rightsAndObligationsExplanation} = true',
                  text: {
                    default: 'Please check this box',
                    'zh-tw': '請確認此選項',
                  },
                },
              ],
              preset: 'confirm_checkbox',
            },
            {
              type: 'boolean',
              name: 'professionalAdviceReminder',
              title: {
                default:
                  'Have you reminded the insurance agent applicant that he/she may seek independent professional advice (including legal advice) for his/her contractual rights and obligations at his/her own cost (if applicable)?',
                'zh-tw':
                  '您是否提醒保險代理人申請人，他/她可以自費（如適用）就其契约權利和義務尋求獨立的專業意見（包括法律意見）？',
              },
              isRequired: true,
              titleLocation: 'left',
              labelTrue: {
                'zh-tw': '是',
                default: 'Yes',
              },
              labelFalse: {
                'zh-tw': '否',
                default: 'No',
              },
              validators: [
                {
                  type: 'expression',
                  expression: '{professionalAdviceReminder} = true',
                  text: {
                    default: 'Please check this box',
                    'zh-tw': '請確認此選項',
                  },
                },
              ],
              preset: 'confirm_checkbox',
            },
            {
              type: 'boolean',
              name: 'contractRelatedEnquiries',
              title: {
                default:
                  "Have you informed the insurance agent applicant of the Insurance Company's contact information for any contract-related enquiries?",
                'zh-tw': '您是否已將保險公司的聯繫方式告知保險代理申請人，以便進行任何與契约相關的査詢？',
              },
              isRequired: true,
              titleLocation: 'left',
              labelTrue: {
                'zh-tw': '是',
                default: 'Yes',
              },
              labelFalse: {
                'zh-tw': '否',
                default: 'No',
              },
              validators: [
                {
                  type: 'expression',
                  expression: '{contractRelatedEnquiries} = true',
                  text: {
                    default: 'Please check this box',
                    'zh-tw': '請確認此選項',
                  },
                },
              ],
              preset: 'confirm_checkbox',
            },
          ],
          title: {
            default: 'Confirmation questions',
            'zh-tw': '確認問題',
          },
          description: {
            default: 'Please tick the box(es) below to confirm',
            'zh-tw': 'Please tick the box(es) below to confirm',
          },
        },
        {
          type: 'panel',
          name: 'dataCollectionAndConsent',
          fieldType: 'Standard',
          elements: [
            {
              type: 'boolean',
              name: 'privacyPolicyAgreement',
              title: {
                default:
                  'By clicking this checkbox, I agree to the [Data Collection and Privacy Policy](https://www.prudential.com.hk/en/privacy-policy/index.html) of Prudential Local Company',
                'zh-tw':
                  '按一下此核取方塊，表示我同意[數據收集和隱私政策](https://www.prudential.com.hk/en/privacy-policy/index.html)保誠本地公司',
              },
              isRequired: true,
              requiredErrorText: {
                default: 'Please check this box',
                'zh-tw': '請確認此選項',
              },
              fieldType: 'Standard',
              titleLocation: 'left',
              labelTrue: {
                'zh-tw': '是',
                default: 'Yes',
              },
              labelFalse: {
                'zh-tw': '否',
                default: 'No',
              },
              validators: [
                {
                  type: 'expression',
                  expression: '{privacyPolicyAgreement} = true',
                  text: {
                    default: 'Please check this box',
                    'zh-tw': '請確認此選項',
                  },
                },
              ],
              preset: 'confirm_checkbox_round',
            },
          ],
          title: {
            default: 'Data Collection and Consent',
            'zh-tw': '數據收集和同意',
          },
          description: {
            default:
              '\nPrudential (referred to as “the Company”, “our”, “we”, or “us” in this Part entitled “Personal Information Collection Statement”) may collect certain personal information from you when you apply to be an insurance agent with us, including without limitation your name, identity card number, passport number, date of birth, photograph(s), contact information, financial and account information, qualifications, compensation, and employment history (“Personal Information”). We may also collect Personal Information about you from third parties such as other insurance companies or agents, educational institutions, government agencies, medical personnel, credit reporting agencies, courts or public records.\n\n1. Purpose of Collection\n\nThe Company may use your Personal Information for the following purposes: (i) to consider your suitability as an agent; (ii) to register you as an agent and to manage the agency relationship; (iii) to communicate with you; (iv) to pay commission and other compensation; (v) for business planning and performance review; (vi) for research and statistical analysis; (vii) for benefit management and administration; (viii) for training and development ; (ix) to provide references; (x) to take any action arising out of, or in connection with, your appointment (including action that might be adverse to your own or any other person’s interest); (xi) recruitment purposes (including recruitment as agent of Companies within the Prudential Group (as defined below)); and (xii) any other purpose directly relating to any of the above purposes.\n\n2. Classes of Transferees\n\nThe Company may disclose your Personal Information to the group of companies including the Company and those of other entities whose ultimate parent company is Prudential plc including but not limited to Prudential (“Companies within the Prudential Group”). and their respective insurance agents, and to financial/health business partners of the Company. The Company may disclose your Personal Information to third parties (within or outside resided region) for the purposes outlined at Section 1 above, including without limitation the following third parties: (i) our third party service providers (including without limitation the insurers, bankers, lawyers, accountants, and other third party service providers who provide administrative, telecommunications, computer, payment or other services to us to enable us to operate our business); (ii) other entities whose ultimate parent company is Prudential plc; (iii) industry associations and federations; (iv) regulators and government agencies; (v) credit reference agencies; (vi) debt collection agencies; (vii) law enforcement agencies; (viii) the Courts; (ix) educational institutions; and (x) our agency force. The Company may also transfer your Personal Information in connection with a transaction with another company which affects the control, governance, structure and/or management of all or a substantial part of our business, or if required to satisfy applicable legal or regulatory requirements.\n\n3. Consequence of failing to provide Personal Information\n\nUnless otherwise specified by us, it is mandatory for you to provide the Personal Information requested by us. In the event that any such Personal Information is not provided, the Company may be unable to provide you with the services or carry out the activities outlined at Section 1 above.',
            'zh-tw':
              '\n當您申請成為我們的保險代理人時，保誠（在本部分題為“個人資訊收集聲明”中稱為“本公司”、“我們的”、“我方”或“我們”）可能會從您那裡收集某些個人資訊，包括但不限於您的姓名、身份證號碼、護照號碼、出生日期、照片、聯繫方式， 財務和帳戶資訊、資格、薪酬和就業歷史（“個人資訊”）。 我們還可能從協力廠商收集有關您的個人資訊，如其他保險公司或代理人、教育機構、政府機構、醫務人員、信用報告機构、法院或公共記錄。',
          },
        },
      ],
      title: {
        default: 'Pre questions',
        'zh-tw': '預先問題',
      },
    },
    {
      name: 'personalData',
      elements: [
        {
          name: 'personalInformation',
          elements: [
            {
              name: 'citizenship',
              title: {
                default: 'Citizenship',
                'zh-tw': 'Citizenship',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Malaysian',
                  text: {
                    default: 'Malaysian',
                    'zh-tw': 'Malaysian',
                  },
                },
                {
                  value: 'Non-Malaysian',
                  text: {
                    default: 'Non-Malaysian',
                    'zh-tw': 'Non-Malaysian',
                  },
                },
              ],
            },
            {
              name: 'countryOfOrigin',
              title: {
                default: 'Country of Origin',
                'zh-tw': 'Country of Origin',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Malaysia',
                  text: {
                    default: 'Malaysia',
                    'zh-tw': 'Malaysia',
                  },
                },
                {
                  value: 'China',
                  text: {
                    default: 'China',
                    'zh-tw': 'China',
                  },
                },
                {
                  value: 'India',
                  text: {
                    default: 'India',
                    'zh-tw': 'India',
                  },
                },
              ],
              showOtherItem: true,
              otherText: {
                default: 'Others (Input)',
                'zh-tw': '其他（請輸入）',
              },
            },
            {
              name: 'surnameEn',
              title: {
                default: 'Surname in English \n',
                'zh-tw': 'Surname in English \n',
              },
              fieldType: 'Standard',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'firstNameEn',
              title: {
                default: 'First Name in English\n',
                'zh-tw': 'First Name in English\n',
              },
              fieldType: 'Standard',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'preferredName',
              title: {
                default: 'Preferred Name',
                'zh-tw': 'Preferred Name',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'identityDocumentType',
              title: {
                default: 'Identity Document Type',
                'zh-tw': 'Identity Document Type',
              },
              fieldType: 'Standard',
              isPII: true,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'NRIC',
                  text: {
                    default: 'NRIC',
                    'zh-tw': 'NRIC',
                  },
                },
              ],
            },
            {
              name: 'identityDocumentNumber',
              title: {
                default: 'Identity Document Number',
                'zh-tw': 'Identity Document Number',
              },
              fieldType: 'Standard',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'nricOldNumber',
              title: {
                default: 'NRIC Old Number',
                'zh-tw': 'NRIC Old Number',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'sex',
              title: {
                default: 'Gender',
                'zh-tw': 'Gender',
              },
              fieldType: 'Standard',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Male',
                'zh-tw': 'Male',
              },
              labelFalse: {
                default: 'Female',
                'zh-tw': 'Female',
              },
            },
            {
              name: 'dateOfBirth',
              title: {
                default: 'Date of Birth',
                'zh-tw': 'Date of Birth',
              },
              fieldType: 'Standard',
              isPII: true,
              isRequired: true,
              type: 'text',
              inputType: 'date',
            },
            {
              name: 'religion',
              title: {
                default: 'Religion',
                'zh-tw': 'Religion',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Muslim',
                  text: {
                    default: 'Muslim',
                    'zh-tw': 'Muslim',
                  },
                },
                {
                  value: 'Buddhist',
                  text: {
                    default: 'Buddhist',
                    'zh-tw': 'Buddhist',
                  },
                },
                {
                  value: 'Christian',
                  text: {
                    default: 'Christian',
                    'zh-tw': 'Christian',
                  },
                },
                {
                  value: 'Hindu',
                  text: {
                    default: 'Hindu',
                    'zh-tw': 'Hindu',
                  },
                },
                {
                  value: 'Others',
                  text: {
                    default: 'Others',
                    'zh-tw': 'Others',
                  },
                },
              ],
            },
            {
              name: 'race',
              title: {
                default: 'Race',
                'zh-tw': 'Race',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Malay',
                  text: {
                    default: 'Malay',
                    'zh-tw': 'Malay',
                  },
                },
                {
                  value: 'Chinese',
                  text: {
                    default: 'Chinese',
                    'zh-tw': 'Chinese',
                  },
                },
                {
                  value: 'Indian',
                  text: {
                    default: 'Indian',
                    'zh-tw': 'Indian',
                  },
                },
              ],
              showOtherItem: true,
              otherText: {
                default: 'Others (Input)',
                'zh-tw': '其他（請輸入）',
              },
            },
            {
              name: 'iApplyAs',
              title: {
                default: 'I would like to apply as ',
                'zh-tw': 'I would like to apply as ',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Full Time',
                  text: {
                    default: 'Full Time',
                    'zh-tw': 'Full Time',
                  },
                },
                {
                  value: 'Part Time',
                  text: {
                    default: 'Part Time',
                    'zh-tw': 'Part Time',
                  },
                },
              ],
            },
            {
              name: 'pcePassDate',
              title: {
                default: 'PCE Passing Date',
                'zh-tw': 'PCE Passing Date',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
              inputType: 'date',
            },
            {
              name: 'ceilliPassDate',
              title: {
                default: 'CEILLI Passing Date',
                'zh-tw': 'CEILLI Passing Date',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: false,
              type: 'text',
              inputType: 'date',
            },
            {
              name: 'prsDate',
              title: {
                default: 'PRS (PRUrising Star) Date ',
                'zh-tw': 'PRS (PRUrising Star) Date ',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
              inputType: 'date',
            },
            {
              name: 'maritalStatus',
              title: {
                default: 'Marital Status',
                'zh-tw': 'Marital Status',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Single',
                  text: {
                    default: 'Single',
                    'zh-tw': 'Single',
                  },
                },
                {
                  value: 'Married',
                  text: {
                    default: 'Married',
                    'zh-tw': 'Married',
                  },
                },
                {
                  value: 'Divorced',
                  text: {
                    default: 'Divorced',
                    'zh-tw': 'Divorced',
                  },
                },
                {
                  value: 'Widowed',
                  text: {
                    default: 'Widowed',
                    'zh-tw': 'Widowed',
                  },
                },
              ],
            },
            {
              name: 'spouseCitizenship',
              title: {
                default: "Spouse's Citizenship",
                'zh-tw': "Spouse's Citizenship",
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'dropdown',
              choices: [
                {
                  value: 'Malaysian',
                  text: {
                    default: 'Malaysian',
                    'zh-tw': 'Malaysian',
                  },
                },
                {
                  value: 'Non-Malaysian',
                  text: {
                    default: 'Non-Malaysian',
                    'zh-tw': 'Non-Malaysian',
                  },
                },
              ],
            },
            {
              name: 'spouseCountryOfOrigin',
              title: {
                default: "Spouse's Country of Origin",
                'zh-tw': "Spouse's Country of Origin",
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'dropdown',
              choices: [
                {
                  value: 'Malaysia',
                  text: {
                    default: 'Malaysia',
                    'zh-tw': 'Malaysia',
                  },
                },
                {
                  value: 'China',
                  text: {
                    default: 'China',
                    'zh-tw': 'China',
                  },
                },
                {
                  value: 'India',
                  text: {
                    default: 'India',
                    'zh-tw': 'India',
                  },
                },
              ],
              showOtherItem: true,
              otherText: {
                default: 'Others (Input)',
                'zh-tw': '其他（請輸入）',
              },
            },
            {
              name: 'spouseNameEn',
              title: {
                default: "Spouse's Name",
                'zh-tw': "Spouse's Name",
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'text',
            },
            {
              name: 'spouseNricNo',
              title: {
                default: "Spouse's New NRIC No",
                'zh-tw': "Spouse's New NRIC No",
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'text',
            },
            {
              name: 'spouseOldNricNo',
              title: {
                default: "Spouse's Old NRIC No/ Passport No",
                'zh-tw': "Spouse's Old NRIC No/ Passport No",
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'text',
            },
            {
              name: 'spouseOccupation',
              title: {
                default: "Spouse's Occupation",
                'zh-tw': "Spouse's Occupation",
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'text',
            },
            {
              name: 'spouseEmployedCompany',
              title: {
                default: 'Employed Company Name of Spouse',
                'zh-tw': 'Employed Company Name of Spouse',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{maritalStatus} = 'Married'",
              type: 'text',
            },
          ],
          title: {
            default: 'Personal Information',
            'zh-tw': 'Personal Information',
          },
          fieldType: 'Standard',
          type: 'panel',
        },
        {
          name: 'contactInformation',
          elements: [
            {
              name: 'address1',
              title: {
                default: 'Corresondence Address Line 1',
                'zh-tw': 'Corresondence Address Line 1',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'address2',
              title: {
                default: 'Corresondence Address Line 2',
                'zh-tw': 'Corresondence Address Line 2',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'address3',
              title: {
                default: 'Corresondence Address Line 3',
                'zh-tw': 'Corresondence Address Line 3',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'postcode',
              title: {
                default: 'Postcode',
                'zh-tw': 'Postcode',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'city',
              title: {
                default: 'City',
                'zh-tw': 'City',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'state',
              title: {
                default: 'State',
                'zh-tw': 'State',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Johor',
                  text: {
                    default: 'Johor',
                    'zh-tw': 'Johor',
                  },
                },
                {
                  value: 'Kedah',
                  text: {
                    default: 'Kedah',
                    'zh-tw': 'Kedah',
                  },
                },
                {
                  value: 'Kelantan',
                  text: {
                    default: 'Kelantan',
                    'zh-tw': 'Kelantan',
                  },
                },
                {
                  value: 'Melaka',
                  text: {
                    default: 'Melaka',
                    'zh-tw': 'Melaka',
                  },
                },
                {
                  value: 'Negeri Sembilan',
                  text: {
                    default: 'Negeri Sembilan',
                    'zh-tw': 'Negeri Sembilan',
                  },
                },
                {
                  value: 'Pahan',
                  text: {
                    default: 'Pahan',
                    'zh-tw': 'Pahan',
                  },
                },
                {
                  value: 'Perak',
                  text: {
                    default: 'Perak',
                    'zh-tw': 'Perak',
                  },
                },
                {
                  value: 'Perlis',
                  text: {
                    default: 'Perlis',
                    'zh-tw': 'Perlis',
                  },
                },
                {
                  value: 'Pulau Pinang',
                  text: {
                    default: 'Pulau Pinang',
                    'zh-tw': 'Pulau Pinang',
                  },
                },
                {
                  value: 'Sabah',
                  text: {
                    default: 'Sabah',
                    'zh-tw': 'Sabah',
                  },
                },
                {
                  value: 'Sarawak',
                  text: {
                    default: 'Sarawak',
                    'zh-tw': 'Sarawak',
                  },
                },
                {
                  value: 'Selangor',
                  text: {
                    default: 'Selangor',
                    'zh-tw': 'Selangor',
                  },
                },
                {
                  value: 'Terengganu',
                  text: {
                    default: 'Terengganu',
                    'zh-tw': 'Terengganu',
                  },
                },
                {
                  value: 'WP-Kuala Lumpur',
                  text: {
                    default: 'WP-Kuala Lumpur',
                    'zh-tw': 'WP-Kuala Lumpur',
                  },
                },
                {
                  value: 'WP-Labuan',
                  text: {
                    default: 'WP-Labuan',
                    'zh-tw': 'WP-Labuan',
                  },
                },
                {
                  value: 'WP-Putrajaya',
                  text: {
                    default: 'WP-Putrajaya',
                    'zh-tw': 'WP-Putrajaya',
                  },
                },
              ],
            },
            {
              type: 'paneldynamic',
              name: 'regionPhone',
              title: 'Region Phone',
              isRequired: true,
              readOnly: true,
              requiredErrorText: ' ',
              templateElements: [
                {
                  type: 'dropdown',
                  name: 'countryCode',
                  title: 'Country Code',
                  isRequired: true,
                  readOnly: true,
                  requiredErrorText: {
                    default: 'Please select option where applicable',
                    'zh-tw': '請選擇適當選項',
                  },
                  fieldType: 'Standard',
                  width: '50%',
                  minWidth: '50%',
                  maxWidth: '50%',
                  titleLocation: 'hidden',
                  choices: [
                    {
                      value: '+852',
                      text: {
                        default: '+852',
                        'zh-tw': '+852',
                      },
                    },
                    {
                      value: '+62',
                      text: {
                        default: '+62',
                        'zh-tw': '+62',
                      },
                    },
                  ],
                  startWithNewLine: false,
                },
                {
                  type: 'text',
                  name: 'mobileNumber',
                  title: 'Mobile No',
                  description: '(Used in license registration,  No country code)',
                  isRequired: true,
                  readOnly: true,
                  requiredErrorText: {
                    default: 'Please enter a valid mobile phone number',
                    'zh-tw': '請輸入符合格式之流動電話號碼',
                  },
                  fieldType: 'Standard',
                  isPII: true,
                  inputType: 'tel',
                  width: '50%',
                  minWidth: '50%',
                  maxWidth: '50%',
                  startWithNewLine: false,
                  titleLocation: 'hidden',
                  validators: [
                    {
                      type: 'expression',
                      expression: 'regionPhoneValidate({#regionPhone[0].countryCode},{regionPhone[0].mobileNumber})',
                      text: {
                        default: 'Please enter a valid mobile phone number',
                        'zh-tw': '請輸入符合格式之流動電話號碼',
                      },
                    },
                  ],
                },
              ],
              allowAddPanel: false,
              allowRemovePanel: false,
              panelCount: 1,
              minPanelCount: 1,
              maxPanelCount: 1,
            },
            {
              name: 'houseNumber',
              title: {
                default: 'House No',
                'zh-tw': 'House No',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'officeNumber',
              title: {
                default: 'Office No',
                'zh-tw': 'Office No',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'personalEmail',
              title: {
                default: 'Personal Email',
                'zh-tw': 'Personal Email',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: false,
              type: 'text',
              inputType: 'email',
            },
          ],
          title: {
            default: 'Contact Information',
            'zh-tw': 'Contact Information',
          },
          fieldType: 'Standard',
          type: 'panel',
        },
        {
          name: 'educationBackground',
          elements: [
            {
              name: 'highestEducation',
              title: {
                default: 'Highest Educational Qualification',
                'zh-tw': 'Highest Educational Qualification',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'SPM or equivalent',
                  text: {
                    default: 'SPM or equivalent',
                    'zh-tw': 'SPM or equivalent',
                  },
                },
                {
                  value: 'STPM or equivalent',
                  text: {
                    default: 'STPM or equivalent',
                    'zh-tw': 'STPM or equivalent',
                  },
                },
                {
                  value: 'Diploma or equivalent',
                  text: {
                    default: 'Diploma or equivalent',
                    'zh-tw': 'Diploma or equivalent',
                  },
                },
                {
                  value: 'Degree or Higher',
                  text: {
                    default: 'Degree or Higher',
                    'zh-tw': 'Degree or Higher',
                  },
                },
                {
                  value: 'Technical',
                  text: {
                    default: 'Technical',
                    'zh-tw': 'Technical',
                  },
                },
              ],
            },
            {
              name: 'schoolName',
              title: {
                default: 'School/College/University Name',
                'zh-tw': 'School/College/University Name',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'eduDurationFrom',
              title: {
                default: 'Duration from',
                'zh-tw': 'Duration from',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
              inputType: 'date',
            },
            {
              name: 'eduDurationTo',
              title: {
                default: 'Duration to',
                'zh-tw': 'Duration to',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
              inputType: 'date',
            },
          ],
          title: {
            default: 'Education Background',
            'zh-tw': 'Education Background',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
      ],
      title: {
        default: 'Personal Data',
        'zh-tw': 'Personal Data',
      },
      fieldType: 'Standard',
    },
    {
      name: 'careerNEmployment',
      elements: [
        {
          name: 'workExperience',
          elements: [
            {
              name: 'staffOfPambOrPrubsn',
              title: {
                default:
                  "Have you ever been a staff of Prudential Assurance Malaysia Berhad (PAMB)/ Prudential BSN Takaful Berhad (PruBSN) or any of its agency's?",
                'zh-tw':
                  "Have you ever been a staff of Prudential Assurance Malaysia Berhad (PAMB)/ Prudential BSN Takaful Berhad (PruBSN) or any of its agency's?",
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              type: 'paneldynamic',
              name: 'staffOfPambOrPrubsnList',
              title: {
                default: 'PAMB or PruBSN staff History',
                'zh-tw': 'PAMB or PruBSN staff History',
              },
              templateElements: [
                {
                  name: 'PambPrubsnDepartment',
                  title: {
                    default: 'Department/ Agency Name',
                    'zh-tw': 'Department/ Agency Name',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'PambPrubsnPosition',
                  title: {
                    default: 'Position Held',
                    'zh-tw': 'Position Held',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'PambPrubsnDurationFrom',
                  title: {
                    default: 'Duration From',
                    'zh-tw': 'Duration From',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
                {
                  name: 'PambPrubsnDurationTo',
                  title: {
                    default: 'Duration To',
                    'zh-tw': 'Duration To',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
                {
                  name: 'PambPrubsnLeaveReason',
                  title: {
                    default: 'Reason for Leaving',
                    'zh-tw': 'Reason for Leaving',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
              ],
              panelCount: 1,
              minPanelCount: 1,
              maxPanelCount: 5,
              confirmDelete: true,
              confirmDeleteText: 'Are you sure you want to delete this?',
              panelAddText: '(+) Add Another Event',
              panelRemoveText: 'Delete',
              visibleIf: "{staffOfPambOrPrubsn} = 'Yes'",
            },
            {
              name: 'workExp',
              title: {
                default: 'Do you have any working experience',
                'zh-tw': 'Do you have any working experience',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
              defaultValue: false,
            },
            {
              name: 'noWorkExpReason',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{workExp} = 'No'",
              type: 'text',
            },
            {
              name: 'workExpDetails',
              title: {
                default: 'Please provide your current and past employment details, if any for the past 7 years.',
                'zh-tw': 'Please provide your current and past employment details, if any for the past 7 years.',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              type: 'paneldynamic',
              name: 'workExpDetailsList',
              title: {
                default: 'Past Working Experience',
                'zh-tw': 'Past Working Experience',
              },
              templateElements: [
                {
                  name: 'workExpCompany',
                  title: {
                    default: 'Company Name & Address',
                    'zh-tw': 'Company Name & Address',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'workExpPosition',
                  title: {
                    default: 'Position Held',
                    'zh-tw': 'Position Held',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'workExpBusiness',
                  title: {
                    default: 'Type of Business/ Product',
                    'zh-tw': 'Type of Business/ Product',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'workExpSelling',
                  title: {
                    default: 'Any Selling Experience',
                    'zh-tw': 'Any Selling Experience',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'boolean',
                  labelTrue: {
                    default: 'Yes',
                    'zh-tw': 'Yes',
                  },
                  labelFalse: {
                    default: 'No',
                    'zh-tw': 'No',
                  },
                },
                {
                  name: 'workExpDurationFrom',
                  title: {
                    default: 'Duration From',
                    'zh-tw': 'Duration From',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
                {
                  name: 'workExpDurationTo',
                  title: {
                    default: 'Duration To',
                    'zh-tw': 'Duration To',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
                {
                  name: 'workExpRm',
                  title: {
                    default: 'Annual Income (RM)',
                    'zh-tw': 'Annual Income (RM)',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'workExpLeaveReason',
                  title: {
                    default: 'Reason for Leaving',
                    'zh-tw': 'Reason for Leaving',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'workExpContact',
                  title: {
                    default: 'Company Person to Contact',
                    'zh-tw': 'Company Person to Contact',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
              ],
              panelCount: 1,
              minPanelCount: 1,
              maxPanelCount: 5,
              confirmDelete: true,
              confirmDeleteText: 'Are you sure you want to delete this?',
              panelAddText: '(+) Add Another Event',
              panelRemoveText: 'Delete',
              visibleIf: "{workExp} = 'Yes'",
            },
            {
              name: 'sellingExp',
              title: {
                default:
                  'Do you have any selling experience or have acted as an agent either directly or indirectly in the life insurance/ takaful industry or similar institutions?',
                'zh-tw':
                  'Do you have any selling experience or have acted as an agent either directly or indirectly in the life insurance/ takaful industry or similar institutions?',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              type: 'paneldynamic',
              name: 'sellingExpList',
              title: {
                default: 'Previous Selling Experience',
                'zh-tw': 'Previous Selling Experience',
              },
              templateElements: [
                {
                  name: 'sellingExpCompany',
                  title: {
                    default: 'Company Name',
                    'zh-tw': 'Company Name',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'sellingExpBusiness',
                  title: {
                    default: 'Type of Business / Product',
                    'zh-tw': 'Type of Business / Product',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'sellingExpDurationFrom',
                  title: {
                    default: 'Duration From',
                    'zh-tw': 'Duration From',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
                {
                  name: 'sellingExpDurationTo',
                  title: {
                    default: 'Duration To',
                    'zh-tw': 'Duration To',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
              ],
              panelCount: 1,
              minPanelCount: 1,
              maxPanelCount: 5,
              confirmDelete: true,
              confirmDeleteText: 'Are you sure you want to delete this?',
              panelAddText: '(+) Add Another Event',
              panelRemoveText: 'Delete',
              visibleIf: "{sellingExp} = 'Yes'",
            },
            {
              name: 'familyIsAgentOrStaff',
              title: {
                default:
                  'Are any of your family member (including spouse and children) an agent or a staff of Prudential Assurance Malaysia Berhad, Prudential\nBSN Takaful Berhad and / or Eastspring Investments Berhad?',
                'zh-tw':
                  'Are any of your family member (including spouse and children) an agent or a staff of Prudential Assurance Malaysia Berhad, Prudential\nBSN Takaful Berhad and / or Eastspring Investments Berhad?',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
              defaultValue: false,
            },
            {
              type: 'paneldynamic',
              name: 'familyIsAgentOrStaffList',
              title: {
                default: 'Family as Agent',
                'zh-tw': 'Family as Agent',
              },
              templateElements: [
                {
                  name: 'familyName',
                  title: {
                    default: 'Name',
                    'zh-tw': 'Name',
                  },
                  fieldType: 'Custom',
                  isPII: true,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'familyNric',
                  title: {
                    default: 'New NRIC No',
                    'zh-tw': 'New NRIC No',
                  },
                  fieldType: 'Custom',
                  isPII: true,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'familyCompany',
                  title: {
                    default: 'Company Name',
                    'zh-tw': 'Company Name',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'dropdown',
                  choices: [
                    {
                      value: 'Eastspring Investment Berhad',
                      text: {
                        default: 'Eastspring Investment Berhad',
                        'zh-tw': 'Eastspring Investment Berhad',
                      },
                    },
                    {
                      value: 'Prudential Assurance Malaysia Berhad',
                      text: {
                        default: 'Prudential Assurance Malaysia Berhad',
                        'zh-tw': 'Prudential Assurance Malaysia Berhad',
                      },
                    },
                    {
                      value: 'Prudential BSN Takaful Berhad',
                      text: {
                        default: 'Prudential BSN Takaful Berhad',
                        'zh-tw': 'Prudential BSN Takaful Berhad',
                      },
                    },
                  ],
                },
                {
                  name: 'familyCompanyAddress',
                  title: {
                    default: 'Company Address',
                    'zh-tw': 'Company Address',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'familyPosition',
                  title: {
                    default: 'Position Held',
                    'zh-tw': 'Position Held',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'familyRelationship',
                  title: {
                    default: 'Relationship to Applicant',
                    'zh-tw': 'Relationship to Applicant',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'dropdown',
                  choices: [
                    {
                      value: 'Child',
                      text: {
                        default: 'Child',
                        'zh-tw': 'Child',
                      },
                    },
                    {
                      value: 'Spouse',
                      text: {
                        default: 'Spouse',
                        'zh-tw': 'Spouse',
                      },
                    },
                    {
                      value: 'Parent',
                      text: {
                        default: 'Parent',
                        'zh-tw': 'Parent',
                      },
                    },
                    {
                      value: 'Sibling',
                      text: {
                        default: 'Sibling',
                        'zh-tw': 'Sibling',
                      },
                    },
                  ],
                  showOtherItem: true,
                  otherText: {
                    default: 'Others (Input)',
                    'zh-tw': '其他（請輸入）',
                  },
                },
                {
                  name: 'familyAgentCode',
                  title: {
                    default: 'Agent Code',
                    'zh-tw': 'Agent Code',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
              ],
              panelCount: 1,
              minPanelCount: 1,
              maxPanelCount: 5,
              confirmDelete: true,
              confirmDeleteText: 'Are you sure you want to delete this?',
              panelAddText: '(+) Add Another Event',
              panelRemoveText: 'Delete',
              visibleIf: "{familyIsAgentOrStaff} = 'Yes'",
            },
          ],
          title: {
            default: 'Work Experience',
            'zh-tw': 'Work Experience',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
      ],
      title: {
        default: 'Career and Employment',
        'zh-tw': 'Career and Employment',
      },
      fieldType: 'Custom',
    },
    {
      name: 'declarations',
      elements: [
        {
          name: 'healthDetails',
          elements: [
            {
              name: 'illnessOrAccident',
              title: {
                default:
                  'Have you had any illness, operation or accident requireing protracted medical attention? (If yes, please provide latest medical report)',
                'zh-tw':
                  'Have you had any illness, operation or accident requireing protracted medical attention? (If yes, please provide latest medical report)',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              type: 'paneldynamic',
              name: 'Parent key: healthDetailsList',
              title: {
                default: 'Health Details',
                'zh-tw': 'Health Details',
              },
              templateElements: [
                {
                  name: 'diagnoseDate',
                  title: {
                    default: 'Diagnose Date',
                    'zh-tw': 'Diagnose Date',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                  inputType: 'date',
                },
                {
                  name: 'illnessName',
                  title: {
                    default: 'Illness/ Disease Name',
                    'zh-tw': 'Illness/ Disease Name',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
                {
                  name: 'hospitalName',
                  title: {
                    default: 'Hospital/ Clinic Name',
                    'zh-tw': 'Hospital/ Clinic Name',
                  },
                  fieldType: 'Custom',
                  isPII: false,
                  isRequired: true,
                  type: 'text',
                },
              ],
              panelCount: 1,
              minPanelCount: 1,
              maxPanelCount: 5,
              confirmDelete: true,
              confirmDeleteText: 'Are you sure you want to delete this?',
              panelAddText: '(+) Add Another Event',
              panelRemoveText: 'Delete',
              visibleIf: "{illnessOrAccident} = 'Yes'",
            },
          ],
          title: {
            default: 'Health Detail',
            'zh-tw': 'Health Detail',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
        {
          name: 'applicationDeclaration',
          elements: [
            {
              name: 'insolventOrBankrupt',
              title: {
                default: 'I am not an insolvent under administration or an undischarged bankrupt',
                'zh-tw': 'I am not an insolvent under administration or an undischarged bankrupt',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'insolventDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{insolventOrBankrupt} = 'No'",
              type: 'text',
            },
            {
              name: 'criminalOffence',
              title: {
                default:
                  'I am not convicted of any offence within or outside of Malaysia involving fraud or dishonesty or other criminal offence and/ or any other ',
                'zh-tw':
                  'I am not convicted of any offence within or outside of Malaysia involving fraud or dishonesty or other criminal offence and/ or any other ',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'criminalOffenceDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{criminalOffence} = 'No'",
              type: 'text',
            },
            {
              name: 'litigation',
              title: {
                default: 'I am involved in any litigation cases currently',
                'zh-tw': 'I am involved in any litigation cases currently',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'litigationDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{litigationDetails} = 'No'",
              type: 'text',
            },
            {
              name: 'imprisonment',
              title: {
                default:
                  'I have never been imprisoned for any offence within the period of five years from the date of this application',
                'zh-tw':
                  'I have never been imprisoned for any offence within the period of five years from the date of this application',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'imprisonmentDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{imprisonment} = 'No'",
              type: 'text',
            },
            {
              name: 'familyIsAgent',
              title: {
                default:
                  'My immediate family members are/ were not an agent of any Insurance Company/ Takaful Operator, and have no record of disciplinary proceedings',
                'zh-tw':
                  'My immediate family members are/ were not an agent of any Insurance Company/ Takaful Operator, and have no record of disciplinary proceedings',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'familyIsAgentDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{familyIsAgent} = 'No'",
              type: 'text',
            },
            {
              name: 'familyIsStaff',
              title: {
                default:
                  'My immediate family members are/ were not a staff of any Insurance Company/ Takaful Operator, and have no record of disciplinary proceedings.',
                'zh-tw':
                  'My immediate family members are/ were not a staff of any Insurance Company/ Takaful Operator, and have no record of disciplinary proceedings.',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'familyIsStaffDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{familyIsStaffDetails} = 'No'",
              type: 'text',
            },
            {
              name: 'familyIsSeniorManagement',
              title: {
                default:
                  'My immediate faily members are/ were not appointed as senior management or directors of any Insurance Company/ Takaful Operator',
                'zh-tw':
                  'My immediate faily members are/ were not appointed as senior management or directors of any Insurance Company/ Takaful Operator',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'boolean',
              labelTrue: {
                default: 'Yes',
                'zh-tw': 'Yes',
              },
              labelFalse: {
                default: 'No',
                'zh-tw': 'No',
              },
            },
            {
              name: 'familyIsSeniorManagementDetails',
              title: {
                default: 'If no, please provide details',
                'zh-tw': 'If no, please provide details',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              visibleIf: "{familyIsSeniorManagement} = 'No'",
              type: 'text',
            },
          ],
          title: {
            default: 'Application Declaration',
            'zh-tw': 'Application Declaration',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
        {
          name: 'introducerDetails',
          elements: [
            {
              name: 'introducerAgentCode',
              title: {
                default: "Introducer's Agent ID",
                'zh-tw': "Introducer's Agent ID",
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'introducerName',
              title: {
                default: "Introducer's Name",
                'zh-tw': "Introducer's Name",
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'introducerNewNricNo',
              title: {
                default: "Introducer's new NRIC No",
                'zh-tw': "Introducer's new NRIC No",
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'relationshipWithApplicant',
              title: {
                default: 'Relationship with applicant',
                'zh-tw': 'Relationship with applicant',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'Friend',
                  text: {
                    default: 'Friend',
                    'zh-tw': 'Friend',
                  },
                },
                {
                  value: 'Kawan',
                  text: {
                    default: 'Kawan',
                    'zh-tw': 'Kawan',
                  },
                },
                {
                  value: 'Sibling',
                  text: {
                    default: 'Sibling',
                    'zh-tw': 'Sibling',
                  },
                },
                {
                  value: 'Spouse',
                  text: {
                    default: 'Spouse',
                    'zh-tw': 'Spouse',
                  },
                },
              ],
              showOtherItem: true,
              otherText: {
                default: 'Others (Input)',
                'zh-tw': '其他（請輸入）',
              },
            },
          ],
          title: {
            default: 'Introducer Details',
            'zh-tw': 'Introducer Details',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
        {
          name: 'autopayForm',
          elements: [
            {
              name: 'payeeName',
              title: {
                default: 'Payee Name',
                'zh-tw': 'Payee Name',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'payeeIdType',
              title: {
                default: 'Payee ID Type',
                'zh-tw': 'Payee ID Type',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'payeeIdNo',
              title: {
                default: 'Payee ID No',
                'zh-tw': 'Payee ID No',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'payeeBankName',
              title: {
                default: 'Bank Name',
                'zh-tw': 'Bank Name',
              },
              fieldType: 'Custom',
              isPII: false,
              isRequired: true,
              type: 'dropdown',
              choices: [
                {
                  value: 'STANDARD CHARTERED BANK (HONG KONG) LIMITED (003)',
                  text: {
                    default: 'STANDARD CHARTERED BANK (HONG KONG) LIMITED (003)',
                    'zh-tw': '渣打銀行（香港）有限公司3',
                  },
                },
                {
                  value: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED (HSBC) (004)',
                  text: {
                    default: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED (HSBC) (004)',
                    'zh-tw': '香港上海滙豐銀行有限公司（HSBC）4',
                  },
                },
                {
                  value: 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK (005)',
                  text: {
                    default: 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK (005)',
                    'zh-tw': '農業信貸公司和投資銀行5',
                  },
                },
                {
                  value: 'CITIBANK, N.A. (006)',
                  text: {
                    default: 'CITIBANK, N.A. (006)',
                    'zh-tw': '花旗銀行，N.A.6',
                  },
                },
                {
                  value: 'JPMORGAN CHASE BANK, N.A. (007)',
                  text: {
                    default: 'JPMORGAN CHASE BANK, N.A. (007)',
                    'zh-tw': '摩根大通銀行，美國7',
                  },
                },
                {
                  value: 'NATWEST MARTETS PLC (008)',
                  text: {
                    default: 'NATWEST MARTETS PLC (008)',
                    'zh-tw': '納特維斯馬特股份有限公司8',
                  },
                },
                {
                  value: 'CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED (009)',
                  text: {
                    default: 'CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED (009)',
                    'zh-tw': '中國建設銀行（亞洲）股份有限公司9',
                  },
                },
                {
                  value: 'BANK OF CHINA (HONG KONG) LIMITED (012)',
                  text: {
                    default: 'BANK OF CHINA (HONG KONG) LIMITED (012)',
                    'zh-tw': '中國銀行（香港）有限公司12',
                  },
                },
                {
                  value: 'THE BANK OF EAST ASIA, LIMITED (015)',
                  text: {
                    default: 'THE BANK OF EAST ASIA, LIMITED (015)',
                    'zh-tw': '東亞銀行有限公司15',
                  },
                },
                {
                  value: 'DBS BANK (HONG KONG) LIMITED (016)',
                  text: {
                    default: 'DBS BANK (HONG KONG) LIMITED (016)',
                    'zh-tw': '德意志銀行（香港）有限公司16',
                  },
                },
                {
                  value: 'CHINA CITIC BANK INTERNATIONAL LIMITED (018)',
                  text: {
                    default: 'CHINA CITIC BANK INTERNATIONAL LIMITED (018)',
                    'zh-tw': '中信銀行國際有限公司18',
                  },
                },
                {
                  value: 'CMB WING LUNG BANK LIMITED. (020)',
                  text: {
                    default: 'CMB WING LUNG BANK LIMITED. (020)',
                    'zh-tw': 'CMB翼肺銀行有限公司。20',
                  },
                },
                {
                  value: 'OVERSEA-CHINESE BANKING CORPORATION LTD. (022)',
                  text: {
                    default: 'OVERSEA-CHINESE BANKING CORPORATION LTD. (022)',
                    'zh-tw': '海外-中國銀行股份有限公司22',
                  },
                },
                {
                  value: 'HANG SENG BANK LTD. (024)',
                  text: {
                    default: 'HANG SENG BANK LTD. (024)',
                    'zh-tw': '恒生銀行有限公司24',
                  },
                },
                {
                  value: 'SHANGHAI COMMERCIAL BANK LTD. (025)',
                  text: {
                    default: 'SHANGHAI COMMERCIAL BANK LTD. (025)',
                    'zh-tw': '上海商業銀行股份有限公司25',
                  },
                },
                {
                  value: 'BANK OF COMMUNICATIONS CO., LTD (027)',
                  text: {
                    default: 'BANK OF COMMUNICATIONS CO., LTD (027)',
                    'zh-tw': '交通銀行股份有限公司27',
                  },
                },
                {
                  value: 'PUBLIC BANK (HONG KONG) LIMITED (028)',
                  text: {
                    default: 'PUBLIC BANK (HONG KONG) LIMITED (028)',
                    'zh-tw': '公共銀行（香港）有限公司28',
                  },
                },
                {
                  value: 'OCBC WING HANG BANK LIMITED (035)',
                  text: {
                    default: 'OCBC WING HANG BANK LIMITED (035)',
                    'zh-tw': '華僑銀行永亨銀行有限公司35',
                  },
                },
                {
                  value: 'TAI YAU BANK LTD. (038)',
                  text: {
                    default: 'TAI YAU BANK LTD. (038)',
                    'zh-tw': '太古銀行有限公司38',
                  },
                },
                {
                  value: 'CHIYU BANKING CORPORATION LTD. (039)',
                  text: {
                    default: 'CHIYU BANKING CORPORATION LTD. (039)',
                    'zh-tw': '池裕銀行股份有限公司39',
                  },
                },
                {
                  value: 'DAH SING BANK, LTD. (040)',
                  text: {
                    default: 'DAH SING BANK, LTD. (040)',
                    'zh-tw': '和新加坡銀行有限公司40',
                  },
                },
                {
                  value: 'CHONG HING BANK LIMITED (041)',
                  text: {
                    default: 'CHONG HING BANK LIMITED (041)',
                    'zh-tw': '中興銀行有限公司41',
                  },
                },
                {
                  value: 'NANYANG COMMERCIAL BANK, LTD. (043)',
                  text: {
                    default: 'NANYANG COMMERCIAL BANK, LTD. (043)',
                    'zh-tw': '南陽商業銀行股份有限公司43',
                  },
                },
                {
                  value: 'UCO BANK (045)',
                  text: {
                    default: 'UCO BANK (045)',
                    'zh-tw': 'UCO銀行45',
                  },
                },
                {
                  value: 'KEB HANA BANK (046)',
                  text: {
                    default: 'KEB HANA BANK (046)',
                    'zh-tw': 'KEB HANA銀行_',
                  },
                },
                {
                  value: 'MUFG BANK, LTD. (047)',
                  text: {
                    default: 'MUFG BANK, LTD. (047)',
                    'zh-tw': 'MUFG銀行有限公司47',
                  },
                },
                {
                  value: 'BANGKOK BANK PUBLIC COMPANY LIMITED (049)',
                  text: {
                    default: 'BANGKOK BANK PUBLIC COMPANY LIMITED (049)',
                    'zh-tw': '曼谷銀行股份有限公司49',
                  },
                },
                {
                  value: 'INDIAN OVERSEAS BANK (050)',
                  text: {
                    default: 'INDIAN OVERSEAS BANK (050)',
                    'zh-tw': '印度海外銀行50',
                  },
                },
                {
                  value: 'DBS BANK LTD. (052)',
                  text: {
                    default: 'DBS BANK LTD. (052)',
                    'zh-tw': '德意志銀行股份有限公司52',
                  },
                },
                {
                  value: 'DEUTSCHE BANK AG (054)',
                  text: {
                    default: 'DEUTSCHE BANK AG (054)',
                    'zh-tw': '德意志銀行AG 54',
                  },
                },
                {
                  value: 'BANK OF AMERICA, N.A. (055)',
                  text: {
                    default: 'BANK OF AMERICA, N.A. (055)',
                    'zh-tw': '美國銀行，N.A.55',
                  },
                },
                {
                  value: 'BNP PARIBAS (056)',
                  text: {
                    default: 'BNP PARIBAS (056)',
                    'zh-tw': '巴黎銀行56',
                  },
                },
                {
                  value: 'BANK OF INDIA (058)',
                  text: {
                    default: 'BANK OF INDIA (058)',
                    'zh-tw': '印度銀行58',
                  },
                },
                {
                  value: 'NATIONAL BANK OF PAKISTAN (060)',
                  text: {
                    default: 'NATIONAL BANK OF PAKISTAN (060)',
                    'zh-tw': '巴基斯坦國家銀行60',
                  },
                },
                {
                  value: 'TAI SANG BANK LIMITED (061)',
                  text: {
                    default: 'TAI SANG BANK LIMITED (061)',
                    'zh-tw': '泰盛銀行有限公司61',
                  },
                },
                {
                  value: 'MALAYAN BANKING BERHAD (MAYBANK) (063)',
                  text: {
                    default: 'MALAYAN BANKING BERHAD (MAYBANK) (063)',
                    'zh-tw': '馬來西亞銀行（馬來亞銀行）63',
                  },
                },
                {
                  value: 'SUMITOMO MITSUI BANKING CORPORATION (065)',
                  text: {
                    default: 'SUMITOMO MITSUI BANKING CORPORATION (065)',
                    'zh-tw': '三井住友銀行65',
                  },
                },
                {
                  value: 'PT. BANK NEGARA INDONESIA (PERSERO) TBK. (066)',
                  text: {
                    default: 'PT. BANK NEGARA INDONESIA (PERSERO) TBK. (066)',
                    'zh-tw': '印尼國家銀行（印尼）TBK.66',
                  },
                },
                {
                  value: 'BDO UNIBANK, INC. (067)',
                  text: {
                    default: 'BDO UNIBANK, INC. (067)',
                    'zh-tw': 'BDO聯合銀行股份有限公司：+967',
                  },
                },
                {
                  value: 'UNITED OVERSEAS BANK LTD. (071)',
                  text: {
                    default: 'UNITED OVERSEAS BANK LTD. (071)',
                    'zh-tw': '聯合海外銀行股份有限公司71',
                  },
                },
                {
                  value: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LIMITED (072)',
                  text: {
                    default: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LIMITED (072)',
                    'zh-tw': '中國工商銀行（亞洲）有限公司72',
                  },
                },
                {
                  value: 'BARCLAYS BANK PLC. (074)',
                  text: {
                    default: 'BARCLAYS BANK PLC. (074)',
                    'zh-tw': '巴克萊銀行',
                  },
                },
                {
                  value: 'THE BANK OF NOVA SCOTIA (076)',
                  text: {
                    default: 'THE BANK OF NOVA SCOTIA (076)',
                    'zh-tw': '新蘇格蘭銀行76',
                  },
                },
                {
                  value: 'ROYAL BANK OF CANADA (080)',
                  text: {
                    default: 'ROYAL BANK OF CANADA (080)',
                    'zh-tw': '加拿大皇家銀行80',
                  },
                },
                {
                  value: 'SOCIETE GENERALE (081)',
                  text: {
                    default: 'SOCIETE GENERALE (081)',
                    'zh-tw': '一般社會81',
                  },
                },
                {
                  value: 'STATE BANK OF INDIA (082)',
                  text: {
                    default: 'STATE BANK OF INDIA (082)',
                    'zh-tw': '印度國家銀行82',
                  },
                },
                {
                  value: 'THE TORONTO-DOMINION BANK (085)',
                  text: {
                    default: 'THE TORONTO-DOMINION BANK (085)',
                    'zh-tw': '多倫多-多明尼翁銀行85',
                  },
                },
                {
                  value: '086 BANK OF MONTREAL (086)',
                  text: {
                    default: '086 BANK OF MONTREAL (086)',
                    'zh-tw': '086蒙特利爾銀行86',
                  },
                },
                {
                  value: 'CANADIAN IMPERIAL BANK OF COMMERCE (092)',
                  text: {
                    default: 'CANADIAN IMPERIAL BANK OF COMMERCE (092)',
                    'zh-tw': '加拿大帝國商業銀行92',
                  },
                },
                {
                  value: 'COMMERZBANK AG (097)',
                  text: {
                    default: 'COMMERZBANK AG (097)',
                    'zh-tw': '商業銀行AG 97',
                  },
                },
                {
                  value: 'UBS AG, HONG KONG (103)',
                  text: {
                    default: 'UBS AG, HONG KONG (103)',
                    'zh-tw': '瑞銀集團，香港103',
                  },
                },
                {
                  value: 'HSBC BANK USA, N.A. (106)',
                  text: {
                    default: 'HSBC BANK USA, N.A. (106)',
                    'zh-tw': '美國滙豐銀行，N.A.106',
                  },
                },
                {
                  value: 'MIZUHO BANK, LTD., HONG KONG BRANCH (109)',
                  text: {
                    default: 'MIZUHO BANK, LTD., HONG KONG BRANCH (109)',
                    'zh-tw': '瑞穗銀行香港分行109',
                  },
                },
                {
                  value: 'DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK (113)',
                  text: {
                    default: 'DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK (113)',
                    'zh-tw': '德國中央銀行德國信貸銀行113',
                  },
                },
                {
                  value: 'WOORI BANK (118)',
                  text: {
                    default: 'WOORI BANK (118)',
                    'zh-tw': '武裏銀行118',
                  },
                },
                {
                  value: 'PHILIPPINE NATIONAL BANK (119)',
                  text: {
                    default: 'PHILIPPINE NATIONAL BANK (119)',
                    'zh-tw': '菲律賓國家銀行119',
                  },
                },
                {
                  value: 'FUBON BANK (HONG KONG) LIMITED (128)',
                  text: {
                    default: 'FUBON BANK (HONG KONG) LIMITED (128)',
                    'zh-tw': '富邦銀行（香港）有限公司128',
                  },
                },
                {
                  value: 'MITSUBISHI UFJ TRUST AND BANKING CORPORATION (138)',
                  text: {
                    default: 'MITSUBISHI UFJ TRUST AND BANKING CORPORATION (138)',
                    'zh-tw': '三菱UFJ信託銀行公司138',
                  },
                },
              ],
            },
            {
              name: 'payeeBankAccountNo',
              title: {
                default: 'Bank Account No',
                'zh-tw': 'Bank Account No',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
            {
              name: 'payeeTaxNo',
              title: {
                default: 'Income Tax No',
                'zh-tw': 'Income Tax No',
              },
              fieldType: 'Custom',
              isPII: true,
              isRequired: true,
              type: 'text',
            },
          ],
          title: {
            default: 'Autopay Form',
            'zh-tw': 'Autopay Form',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
      ],
      title: {
        default: 'Declarations',
        'zh-tw': 'Declarations',
      },
      fieldType: 'Custom',
    },
    {
      name: 'documentUploadModule',
      elements: [
        {
          name: 'documentUploadSection',
          elements: [
            {
              name: 'nricCopy',
              title: {
                default: 'Copy of NRIC',
                'zh-tw': 'Copy of NRIC',
              },
              fieldType: 'Custom',
              isRequired: true,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'highestAcademicCert',
              title: {
                default: 'Highest Academic Cert',
                'zh-tw': 'Highest Academic Cert',
              },
              fieldType: 'Custom',
              isRequired: true,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'selfie',
              title: {
                default: 'Selfie with Front IC',
                'zh-tw': 'Selfie with Front IC',
              },
              fieldType: 'Custom',
              isRequired: true,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'passportPhoto',
              title: {
                default: 'Passport Size Photo',
                'zh-tw': 'Passport Size Photo',
              },
              fieldType: 'Custom',
              isRequired: true,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'previousCompanyReleaseLetter',
              title: {
                default: 'Letter of Release from Previous Insurance Company',
                'zh-tw': 'Letter of Release from Previous Insurance Company',
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'previousEmployersReleaseLetter',
              title: {
                default: 'Letter of release from previous emloyers',
                'zh-tw': 'Letter of release from previous emloyers',
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'previousCompanyAgentMovement',
              title: {
                default: 'Movement of Agent from the Previous Insurance Company',
                'zh-tw': 'Movement of Agent from the Previous Insurance Company',
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'bankAccountStatement',
              title: {
                default: 'Bank Account statement',
                'zh-tw': 'Bank Account statement',
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'medicalReport',
              title: {
                default: 'Medical report',
                'zh-tw': 'Medical report',
              },
              fieldType: 'Custom',
              isRequired: true,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
          ],
          title: {
            default: 'Document Upload',
            'zh-tw': 'Document Upload',
          },
          description: {
            default: 'Please only upload PDF/ JPG/ JPEG/ PNG  <br/> Each file should not be larger than 4MB',
            'zh-tw': 'Please only upload PDF/ JPG/ JPEG/ PNG  <br/> Each file should not be larger than 4MB',
          },
          fieldType: 'Custom',
          type: 'panel',
        },
      ],
      title: {
        default: 'Document Upload',
        'zh-tw': 'Document Upload',
      },
      fieldType: 'Standard',
    },
    {
      name: 'termsNConditionsModule',
      elements: [
        {
          name: 'termsNConditionsSection',
          elements: [
            {
              name: 'agencyAgreement',
              title: {
                default:
                  "Agency Agreement Terms and Conditions contained in the Company Agent Submission Documents which have been completed by the Agent ('Terms and Conditions of Agency Agreement'), the Terms and Conditions of the Agency Agreement made by PT Prudential Life Assurance ('Company') on March 28, 2022, (Acte van Depot) no. 213, dated March 30 2022, made before Hannywati Gunawan Bachelor of Laws, Notary in Jakarta National Terms",
                'zh-tw':
                  "Agency Agreement Terms and Conditions contained in the Company Agent Submission Documents which have been completed by the Agent ('Terms and Conditions of Agency Agreement'), the Terms and Conditions of the Agency Agreement made by PT Prudential Life Assurance ('Company') on March 28, 2022, (Acte van Depot) no. 213, dated March 30 2022, made before Hannywati Gunawan Bachelor of Laws, Notary in Jakarta National Terms",
              },
              fieldType: 'Custom',
              type: 'boolean',
            },
            {
              name: 'agentStatement',
              title: {
                default: "Agent's statement on the completeness of documents as required by the Company.",
                'zh-tw': "Agent's statement on the completeness of documents as required by the Company.",
              },
              fieldType: 'Custom',
              type: 'boolean',
            },
            {
              name: 'tncFooter',
              title: {
                default:
                  '<div style=\\"color: var(--neutrals-grey-99, #999);font-size: 11px;font-style: normal;font-weight: 500;line-height: 15px;\\">The agent agrees to always comply with and remind himself of the entire contents of the Terms and Conditions of the Agency Agreement as stated on this page, without any exceptions including all changes or additions made in the future by the Company, in accordance with the Terms and Conditions of the Agency Agreement.The agent also agrees that if in the future there is or is found that one of the statements or documents provided by the agent is incorrect or suspected to be incorrect, the company has the right to take all necessary actions against the agent, including but not limited to terminating the agency agreement.Furthermore, the Agent acknowledges and agrees that the Terms and Conditions of the Agency Agreement will be signed electronically by the Agent and printed by the Company in 2 (two)11) copies with sufficient stamp duty and have the same power and are effective from the date the Terms and Conditions of this Agency Agreement are signed. by the Company.</div>',
                'zh-tw':
                  '<div style=\\"color: var(--neutrals-grey-99, #999);font-size: 11px;font-style: normal;font-weight: 500;line-height: 15px;\\">The agent agrees to always comply with and remind himself of the entire contents of the Terms and Conditions of the Agency Agreement as stated on this page, without any exceptions including all changes or additions made in the future by the Company, in accordance with the Terms and Conditions of the Agency Agreement.The agent also agrees that if in the future there is or is found that one of the statements or documents provided by the agent is incorrect or suspected to be incorrect, the company has the right to take all necessary actions against the agent, including but not limited to terminating the agency agreement.Furthermore, the Agent acknowledges and agrees that the Terms and Conditions of the Agency Agreement will be signed electronically by the Agent and printed by the Company in 2 (two)11) copies with sufficient stamp duty and have the same power and are effective from the date the Terms and Conditions of this Agency Agreement are signed. by the Company.</div>',
              },
              fieldType: 'Standard',
              type: 'html',
            },
          ],
          title: {
            default: 'Terms & Conditions',
            'zh-tw': 'Terms & Conditions',
          },
          fieldType: 'Standard',
          type: 'panel',
        },
      ],
      title: {
        default: 'T&C',
        'zh-tw': 'T&C',
      },
      fieldType: 'Standard',
    },
    {
      name: 'eSignatureModule',
      elements: [
        {
          name: 'eSignatureSection',
          elements: [
            {
              name: 'recruiterSignature',
              title: {
                default: "Recruiter's Signature",
                'zh-tw': "Recruiter's Signature",
              },
              fieldType: 'Standard',
              isRequired: true,
              type: 'signaturepad',
              backgroundColor: '#F5F5F5',
              signatureWidth: 400,
              signatureHeight: 200,
              penColor: '#333333',
            },
            {
              name: 'recruiterIdentityDocumentType',
              title: {
                default: "Recruiter's Identity Document Type",
                'zh-tw': "Recruiter's Identity Document Type",
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'dropdown',
              choices: [
                {
                  value: 'Permanent Resident Document',
                  text: {
                    default: 'Permanent Resident Document',
                    'zh-tw': 'Permanent Resident Document',
                  },
                },
                {
                  value: 'Passport',
                  text: {
                    default: 'Passport',
                    'zh-tw': 'Passport',
                  },
                },
                {
                  value: 'Permit (configurable on admin portal)',
                  text: {
                    default: 'Permit (configurable on admin portal)',
                    'zh-tw': 'Permit (configurable on admin portal)',
                  },
                },
              ],
            },
            {
              name: 'recruiterIdentityDocumentUpload',
              title: {
                default: "Recruiter's Identity Document Upload",
                'zh-tw': "Recruiter's Identity Document Upload",
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
            {
              name: 'agentLeaderSignature',
              title: {
                default: "Agent Leader's Signature",
                'zh-tw': "Agent Leader's Signature",
              },
              fieldType: 'Standard',
              isRequired: true,
              type: 'signaturepad',
              backgroundColor: '#F5F5F5',
              signatureWidth: 400,
              signatureHeight: 200,
              penColor: '#333333',
            },
            {
              name: 'agentLeaderDocumentType',
              title: {
                default: "Agent Leader's Identity Document Type",
                'zh-tw': "Agent Leader's Identity Document Type",
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'dropdown',
              choices: [
                {
                  value: 'Permanent Resident Document',
                  text: {
                    default: 'Permanent Resident Document',
                    'zh-tw': 'Permanent Resident Document',
                  },
                },
                {
                  value: 'Passport',
                  text: {
                    default: 'Passport',
                    'zh-tw': 'Passport',
                  },
                },
                {
                  value: 'Permit (configurable on admin portal)',
                  text: {
                    default: 'Permit (configurable on admin portal)',
                    'zh-tw': 'Permit (configurable on admin portal)',
                  },
                },
              ],
            },
            {
              name: 'agentLeaderDocumentUpload',
              title: {
                default: "Agent Leader's Identity Document Upload",
                'zh-tw': "Agent Leader's Identity Document Upload",
              },
              fieldType: 'Custom',
              isRequired: false,
              type: 'file',
              allowMultiple: true,
              waitForUpload: true,
              maxSize: 4194304,
              maxFileNumber: 5,
              maxFileNumberErrorText: {
                default: 'The maximum number of files for this item is 5. Please remove one or more files.',
                'zh-tw': '請最多上載5份文件或圖片。',
              },
              acceptedTypes: '.jpeg, .jpg, .png, .pdf',
              acceptedTypesErrorText: {
                default: 'This file type is not accepted. Please select another file.',
                'zh-tw': '系統並不支持此文件類型。請重新選擇文件。',
              },
              needConfirmRemoveFile: true,
            },
          ],
          title: {
            default: 'E-Signature',
            'zh-tw': 'E-Signature',
          },
          fieldType: 'Standard',
          type: 'panel',
        },
      ],
      title: {
        default: 'E-Signature',
        'zh-tw': 'E-Signature',
      },
      fieldType: 'Standard',
    },
  ],
  invalidNumberErrorText: {
    default: 'Please input number',
    'zh-tw': '請輸入數字',
  },
  requiredErrorText: {
    default: 'This field is mandatory',
    'zh-tw': '此為必填項',
  },
  showQuestionNumbers: 'off',
  questionsOnPageMode: 'questionPerPage',
};
